import React from 'react';
import { motion } from 'framer-motion';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const NotFound = () => {

    const classes = useStyles();

    return (
        <motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1}}
			transition={{ duration: 1.5 }}
		>
			<Grid container display='flex' justifyContent='center'>
				<Grid item xs={ 10 } sm={ 8 } md={ 8 } lg={ 8 } xl={ 12 } display='flex' direction='column' alignItems='center'>
					<h1 className={ classes.title }>¡Encuesta no disponible!</h1>
				</Grid>
			</Grid>
		</motion.div>
    )
}

const useStyles = makeStyles({
	title: {
		color: '#fff',
		textAlign: 'center',
		margin: '80px 0px',
		letterSpacing: 1,

		'@media screen and (max-width: 568px)': {
			fontSize: '1.6rem'
		},
		'@media screen and (min-width: 768px)': {
			fontSize: '2rem'
		},
		'@media screen and (min-width: 1024px)': {
			fontSize: '2rem'
		}
	}
});